import { cacheConfig, http } from '../helpers/axiosHelper';

export default class ReasonService {
   async get() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/reason', { ...cacheConfig }).then((response) => {
         return response?.data;
      });
   }
}
